"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.function.name");

var _config = require("../../utils/config");

var _constants = require("../../constants");

var _version = _interopRequireDefault(require("../../constants/version"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var format = function format(next) {
  return function (params) {
    var _getConfig = (0, _config.getConfig)(),
        serviceId = _getConfig.serviceId;

    var data = params.data.reduce(function (last, param) {
      if (param) {
        var name = param.name,
            type = param.type,
            _data = param.data;
        last.push(Object.assign({
          metric: name,
          tags: _objectSpread({
            'service.id': serviceId,
            'service.name': serviceId,
            kepler: _version.default
          }, _data),
          metricType: type,
          value: 1,
          timestamp: Date.now()
        }));
      }

      return last;
    }, []);

    if (data.length) {
      next({
        data: data,
        url: "".concat(_constants.SERVER_URL, "/log/").concat(_constants.METRIC)
      });
    }
  };
};

var _default = format;
exports.default = _default;